import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import ChefForPartyService from '../../services/ChefForPartyService';
import { formatDate } from '../../utils/DateTimeUtils';

interface InputProps {
    houseId: number;
}

const chefForPartyService = new ChefForPartyService();

const COLUMNS: CommonListColumn[] = [
    { label: 'Id', field: 'id' },
    {
        label: 'Booking Type',
        render: (row) => row?.bookingType === 'BOOK_BY_DISH' ? 'Book By Dish' : 'Chef For Party',
    },
    {
        label: 'Date',
        render: (row) => formatDate(row?.date),
    },
    {
        label: 'Time',
        render: (row) => `${row?.bookingType === 'BOOK_BY_DISH' ? 'Visit Time' : 'Serving Time'}: ${row?.time || '-'}`,
    },
    { label: 'Status', field: 'status', type: 'status' },
    { label: 'No of Adults', field: 'noOfAdults' },
    { label: 'No of Children', field: 'noOfChildren' },
    { label: 'No of Dish', field: 'noOfDishes' },
    { label: 'Total Amount', field: 'totalAmount' },
    { label: 'Token Payment Status', field: 'tokenAmountPaymentStatus', type: 'status' },
    { label: 'Remaining Payment Status', field: 'remainingAmountPaymentStatus', type: 'status' },
    {
        label: 'Actions',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/ChefForParty/${row.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

const HouseChefForPartyTab = ({ houseId }: InputProps) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        chefForPartyService
            .getChefForPartyForHouse(houseId, rowsPerPage, page * rowsPerPage, {}, { order: 'DESC', field: 'id' })
            .then((res) => {
                setData(res?.data ?? []);
                setTotal(res?.total ?? 0);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [houseId, page, rowsPerPage]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            emptyText="No Party Found"
        />
    );
};

export default HouseChefForPartyTab;
